import React from "react";
import { Col, Row } from "reactstrap";
import "../../styles/car-item.css";
import { useNavigate } from "react-router-dom";

const CarItem = (props) => {
  const { vehicleNo, imageUrl, model, brand, driveType, fuelType, baseFare } =
    props.item;
  const navigate = useNavigate();

  return (
    <Col lg="5" md="4" sm="6" className="mb-5">
      <div className="car__item">
        <div className="car__img">
          <img src={imageUrl} alt="" className="w-100" />
        </div>

        <div className="car__item-content mt-4">
          <h4 className="section__title text-center">{brand}</h4>
          <h6 className="rent__price text-center mt-">
            ₹{baseFare}.00 <span>/ Hr.</span>
          </h6>

          <div className="car__item-info d-flex align-items-center justify-content-between mt-3 mb-4">
            <span className=" d-flex align-items-center gap-1">
              <i class="ri-car-line"></i> {model}
            </span>
            <span className=" d-flex align-items-center gap-1">
              <i class="ri-settings-2-line"></i> {driveType}
            </span>
            <span className=" d-flex align-items-center gap-1">
              <i class="ri-timer-flash-line"></i> {fuelType}
            </span>
          </div>

          <Row className="d-flex justify-content-center">
            <button
              className="w-50 car__item-btn car__btn-rent"
              onClick={() => {
                navigate(`/cars/${vehicleNo}`);
              }}
              style={{ color: "white" }}
            >
              Rent
            </button>
          </Row>

          {/* <button className=" w-50 car__item-btn car__btn-details">
            <Link to={`/cars/${id}`}>Details</Link>
          </button> */}
        </div>
      </div>
    </Col>
  );
};

export default CarItem;
